import { schema } from 'normalizr';

export const reading = new schema.Entity('readings');
export const readings = [reading];
